export const Divider = () => <hr />;
